import type { IOnOffSwitchProps } from "@similarweb/ui-components";
import { OnOffSwitch } from "@similarweb/ui-components";
import { PlainTooltip } from "@similarweb/ui-components";
import classNames from "classnames";
import * as _ from "lodash";
import type { FC } from "react";

import "./SubDomainsFilter.scss";

interface ISubDomainsFilter extends IOnOffSwitchProps {
    label: string;
    isDisabled?: boolean;
    disabledTooltip?: string;
    dropdownPopupPlacement?: string;
}

export const SubDomainsFilter: FC<ISubDomainsFilter> = (props) => {
    const classnames = classNames("SubDomainsFilter", props.isDisabled ? "SubDomainsFilter--disabled" : null);
    const content = (
        <div
            className={classnames}
            onClick={props.isDisabled ? _.noop : props.onClick}
        >
            {props.label}
            <OnOffSwitch
                className={props.className}
                onClick={_.noop}
                isSelected={props.isSelected}
                isDisabled={props.isDisabled}
            />
        </div>
    );

    if (props.disabledTooltip) {
        return (
            <PlainTooltip tooltipContent={props.disabledTooltip}>
                <div style={{ width: "100%" }}>{content}</div>
            </PlainTooltip>
        );
    } else {
        return content;
    }
};

